import { render } from "./TailorYourDashboard.vue?vue&type=template&id=74f8b932&ts=true"
import script from "./TailorYourDashboard.vue?vue&type=script&lang=ts"
export * from "./TailorYourDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__